export interface GetProductContractsReq {
  pointOfDeliveryId?: string;
  jobsiteId?: string;
  productLineId?: string;
  shippingConditionId?: string;
  salesDocumentTypeId?: string;
  productId?: string;
  shipmentLocationId?: string;
}
